import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
	BranchInformationModel,
	City,
	isBranchInfoValid,
} from '../../models/branch-information.model'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { Subscription } from 'rxjs'
import { Pattern } from 'src/app/shared/constants/patterns.constant'
import { OrganizationsService } from '../../services/organizations.service'

@Component({
	selector: 'app-organization-branch-contact-info',
	templateUrl: './organization-branch-contact-info.component.html',
	styleUrls: ['./organization-branch-contact-info.component.scss'],
})
export class OrganizationBranchContactInfoComponent implements OnInit {
	@Input() branchInformationData = new BranchInformationModel()
	@Output() dataChanged: EventEmitter<any> = new EventEmitter()
	contactInfoForm!: FormGroup
	editInfoMode: boolean = false
	isMobileValid = false
	subscription = new Subscription()
	cities: City[] = []
	branchId = ''
	showContactMessage = false

	isDataValid: isBranchInfoValid = new isBranchInfoValid()
	constructor(
		public translate: TranslateService,
		private organizationsService: OrganizationsService,
		private routeActivate: ActivatedRoute,
		private dialog: MatDialog,
		private toaster: ToastrService
	) {}

	ngOnInit(): void {
		this.routeActivate.params.subscribe(({ id }) => {
			this.branchId = id
		})
	}

	ngOnChanges(): void {
		this.initBasicInformationValues()
	}

	initBasicInformationValues() {
		this.contactInfoForm = new FormGroup({
			mobileNumber: new FormControl(this.branchInformationData?.mobileNumbers),
			landline: new FormControl(this.branchInformationData?.landline, [
				Validators.pattern(Pattern.numWithoutSpace),
			]),
		})
		this.subscription.add(
			this.contactInfoForm.valueChanges.subscribe((res) => {
				this.showContactMessage = false
				this.isDataValid = new isBranchInfoValid()
			})
		)
	}

	submitForm() {
		if (
			!this.getController('landline')?.value?.length &&
			!this.getController('mobileNumber')?.value?.length
		)
			this.showContactMessage = true
		else {
			const body = {
				id: this.branchInformationData?.id,
				landline: this.getController('landline')?.value,
				mobileNumbers: this.getController('mobileNumber').value,
				tenantId: this.branchInformationData?.tenantId,
			}

			this.subscription.add(
				this.organizationsService
					.BranchValidateUniqueContact(body)
					.subscribe((res: any) => {
						this.showContactMessage = false
						this.isDataValid = res?.result
						this.isDataValid?.isInfoValid ? this.updateData(body) : null
					})
			)
		}
	}

	updateData(body: any) {
		this.subscription.add(
			this.organizationsService.updateBranchContactInformation(body).subscribe({
				next: () => {
					this.branchInformationData = {
						...this.branchInformationData,
						...body,
					}
					this.editInfoMode = false
					this.dataChanged.emit()
					this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
				},
			})
		)
	}

	getController(controlName: string) {
		return this.contactInfoForm.controls[controlName] as FormControl
	}

	compareWith(a: any, b: any) {
		return a == b
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
